const storeString = (key: string, data: string) => {
  sessionStorage.setItem(key, data);
};

const getString = (key: string) => {
  return sessionStorage.getItem(key);
};

const storeService = {
  storeString,
  getString,
};

export default storeService;
